import debug from "debug";
// import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/toggle-class';
const log = debug(MODULE_NAME);

const TOGGLE_ELEMENT_ATTR = 'data-toggle-element';
const TOGGLE_ELEMENT_SELECTOR = '['+TOGGLE_ELEMENT_ATTR+']';

const TOGGLE_WITH_ELEMENT_ATTR = 'data-toggle-with-element';
const TOGGLE_WITH_ELEMENT_SELECTOR = '['+TOGGLE_WITH_ELEMENT_ATTR+']';

const HIDE_WITH_ELEMENT_ATTR = 'data-hide-with-element';

const TOGGLE_CLASSNAME_ATTR = 'data-toggle-class-name';

const TOGGLE_CLASS_ELEMENT_ATTR = 'data-toggle-class-target';
const TOGGLE_CLASS_ELEMENT_SELECTOR = '['+TOGGLE_CLASS_ELEMENT_ATTR+']';

const CHECK_TOGGLE_ELEMENT_ATTR = 'data-check-toggle-class-target';
const CHECK_TOGGLE_ELEMENT_SELECTOR = '['+CHECK_TOGGLE_ELEMENT_ATTR+']';

const CHECK_TOGGLE_CLASSNAME_ATTR = 'data-check-toggle-class-name';

const CHECK_TOGGLE_EVENT_ATTR = 'data-check-toggle-event';
const CHECK_TOGGLE_EVENT_SELECTOR ='['+CHECK_TOGGLE_EVENT_ATTR+']';

function toggleElementClassname() {
    const $this = $(this);
    const target = $this.attr(TOGGLE_CLASS_ELEMENT_ATTR);
    const classname = $this.attr(TOGGLE_CLASSNAME_ATTR);

    $(target).toggleClass(classname);
}

const defaultCheck = ($element, classname) => $element.has(classname);

function checkToggleClass($trigger, checkFn = defaultCheck) {
    if ($trigger.length) {
        const target = $trigger.attr(CHECK_TOGGLE_ELEMENT_ATTR);
        const classname = $trigger.attr(CHECK_TOGGLE_CLASSNAME_ATTR);

        $(target).toggleClass(classname, checkFn($trigger, classname));
    }
}

function checkToggleEvent($trigger) {
    if ($trigger.length) {
        const eventName = $trigger.attr(CHECK_TOGGLE_EVENT_ATTR);
        const isUnchecked = !$trigger.is(':checked');

        $(document).trigger(eventName, isUnchecked);
    }
}

function toggleElement() {
    const $this = $(this);
    const target = $this.attr(TOGGLE_ELEMENT_ATTR);

    $(target).toggle();
}

function toggleWithElement() {
    const $this = $(this);
    const target = $this.attr(TOGGLE_WITH_ELEMENT_ATTR);
    const hideTarget = $this.attr(HIDE_WITH_ELEMENT_ATTR);

    $(hideTarget).hide();
    $(target).show();
}

export function exec() {
    $(TOGGLE_CLASS_ELEMENT_SELECTOR).on('click', toggleElementClassname);

    $(TOGGLE_WITH_ELEMENT_SELECTOR).on('click', toggleWithElement);
    
    $(TOGGLE_ELEMENT_SELECTOR).on('click', toggleElement);
    
    $(CHECK_TOGGLE_EVENT_SELECTOR).on('change', function () {
        checkToggleEvent($(this));
    });
    
    $(CHECK_TOGGLE_ELEMENT_SELECTOR).on('change', function() {
        checkToggleClass($(this));
    });

    $(document).on('async_update', function (event, context) {
        log('element', $(context).find(CHECK_TOGGLE_ELEMENT_SELECTOR));

        $(context).find(CHECK_TOGGLE_ELEMENT_SELECTOR).on('change', function() {
            checkToggleClass($(this));
        });
    });

    $(document).ready(function(){
        checkToggleClass($(CHECK_TOGGLE_ELEMENT_SELECTOR), $element =>
            $element.is(':checked')
        );

        checkToggleEvent($(CHECK_TOGGLE_EVENT_SELECTOR));
    });

}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/toggle-class/index.js